import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody, CardHeader } from 'reactstrap';
import {
  TEMPLATE_TYPE_AVAILABILITY,
  TEMPLATE_TYPE_PLURAL_NAME,
  TemplateType,
} from './types';

interface Props {
  selectedType: TemplateType;
}

const TemplatesAdminHeader: FC<Props> = ({ selectedType }) => {
  const { formatMessage } = useIntl();

  return (
    <Card>
      <CardHeader>
        <h4 className="card-header-title">
          {TEMPLATE_TYPE_PLURAL_NAME(formatMessage, selectedType)}
        </h4>
      </CardHeader>
      <CardBody>
        {TEMPLATE_TYPE_AVAILABILITY(formatMessage, selectedType)}
      </CardBody>
    </Card>
  );
};

export default React.memo(TemplatesAdminHeader);
